import { render } from "./AddContactCard.vue?vue&type=template&id=676ea0ee&scoped=true"
import script from "./AddContactCard.vue?vue&type=script&lang=js"
export * from "./AddContactCard.vue?vue&type=script&lang=js"

import "./AddContactCard.vue?vue&type=style&index=0&id=676ea0ee&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676ea0ee"]])

export default __exports__